module.exports = __webpack_public_path__ + "img/partner_logo_01bosserhoff.32794ee1.jpg";